export default {
  ODONTO: 'odonto',
  CANCELLATION: 'cancelamento',
  RESID: 'residencial',
  AUTO: 'auto',
  WELFARE: 'realiza-saude',
  PET: 'realiza-pet',
};
